import React from 'react';
import PropTypes from 'prop-types';

const ArrowLeft = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="arrow-left" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M5.58710594,7.7655654 L11,13.1666667 L16.4128941,7.7655654 C16.8035426,7.37576799 17.4361129,7.3761129 17.8263361,7.76633609 L18.2928932,8.23289322 C18.6834175,8.62341751 18.6834175,9.25658249 18.2928932,9.64710678 L11.7071068,16.2328932 C11.3165825,16.6234175 10.6834175,16.6234175 10.2928932,16.2328932 L3.70710678,9.64710678 C3.31658249,9.25658249 3.31658249,8.62341751 3.70710678,8.23289322 L4.17366391,7.76633609 C4.5638871,7.3761129 5.19645744,7.37576799 5.58710594,7.7655654 Z" id="Shape" fill={color} fillRule="nonzero" transform="translate(11.000000, 12.000000) rotate(-270.000000) translate(-11.000000, -12.000000) "></path>
      </g>
    </svg>
  );
}

ArrowLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowLeft.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default ArrowLeft;



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowLeft.jsx